import { LogoBlue, WilLogo } from "@/assets";
import { useAppSelector } from "@/store";
import NProgress from "nprogress";
import PageTitle from "@/components/PageTitle";
import { useEffect } from "react";

const PubCompone = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  const darkMode = useAppSelector((state) => state.app.theme);
  useEffect(() => {
    NProgress.start();
    setTimeout(() => {
      NProgress.done();
    }, 1000);
  }, []);
  return (
    <>
      <PageTitle title={title} />
      <div className="h-svh bg-no-repeat bg-cover bg-center flex justify-center items-center loginBg">
        <div className="w-[630px] bg-[#fff] dark:bg-[#141414] rounded-[24px] p-[60px] pt-3">
          <div className="h-28 flex justify-center">
            <img
              src={darkMode === "dark" ? WilLogo : LogoBlue}
              alt=""
              srcSet=""
              width={260}
              height={50}
            />
          </div>
          <>{children}</>
        </div>
      </div>
    </>
  );
};

export default PubCompone;
